<template>
    <div class="cars-list">
        <div class="car-item-container" v-for="item in cars">
            <a :href="item.href"  @click.prevent="goDetail(item)">
                <div class="car-item"
                    is="CarItem"
                    :data="item">
                </div>
            </a>
        </div>
    </div>
</template>

<script>
    import CarItem from '@souche-f2e/wangzhan-dependencies-car-item/vue/Horizontal.vue';
    import urlUtil from '@souche-f2e/chunyan-util/url_util/url_util.js';

    import Store from 'store';

    import {
        buy
    } from '../../../api/json/car.js';
    import { id as getNearlyShopCarId } from '../../../api/shop/recommend/consignment/car';

    let locationObj = urlUtil.initByLocation();

    export default {
        data() {
            return {
                cars: []
            };
        },
        created() {
            let params = Object.assign({}, locationObj.search._object, {
                aggregateConsignmentFlag: true
            });
            buy(params).then((data) => {
                this.cars = data.items.map((carItem) => {
                    if (carItem.consignmentAggregate) {
                        carItem.href = `/car/${carItem.id}?consignmentAggregate=true`;
                    } else {
                        carItem.href = `/car/${carItem.id}`;
                    }
                    return carItem;
                });
                console.log(this.cars);
            });
        },
        methods: {
            goDetail(carItem) {
                let storeCoordinate = Store.get('USER_COORDINATE') || {};
                let coordinate = storeCoordinate.longitude && storeCoordinate.latitude ? `${storeCoordinate.longitude},${storeCoordinate.latitude}` : '';
                if (carItem.consignmentAggregate) {
                    getNearlyShopCarId(carItem.id, carItem.modelCode, coordinate).then((res) => {
                        window.location.href = `/car/${res.carId}?consignmentAggregate=true`;
                    }).catch(() => {
                        window.location.href = `/car/${carItem.id}?consignmentAggregate=true`;
                    });
                } else {
                    window.location.href = `/car/${carItem.id}`;
                }
            }
        },
        components: {
            CarItem
        }
    };
</script>

<style lang="less" scoped>
.cars-list {
    .car-item-container {
        margin-left: 20px;
        border-bottom: 1px solid #F2F2F2;
    }
}
</style>



// WEBPACK FOOTER //
// ListBox.vue?6d4cb96a